import * as index from './index';
index.PivotView.Inject(index.GroupingBar, index.FieldList, index.CalculatedField, index.ConditionalFormatting, index.VirtualScroll, index.DrillThrough, index.Toolbar, index.PivotChart, index.PDFExport, index.ExcelExport, index.NumberFormatting, index.Grouping, index.Pager);
index.PivotFieldList.Inject(index.CalculatedField);
export * from './index';
